import * as React from 'react'

function SvgBank(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5 12a1.5 1.5 0 00.78-2.781l-11.5-7a1.5 1.5 0 00-1.56 0l-11.5 7A1.5 1.5 0 003.5 12h23zM8.85 9L15 5.256 21.15 9H8.85zM7.5 14A1.5 1.5 0 019 15.5v5a1.5 1.5 0 01-3 0v-5A1.5 1.5 0 017.5 14zm7.5 0a1.5 1.5 0 011.5 1.5v5a1.5 1.5 0 11-3 0v-5A1.5 1.5 0 0115 14zm9 1.5a1.5 1.5 0 10-3 0v5a1.5 1.5 0 003 0v-5zm4 10a1.5 1.5 0 01-1.5 1.5h-23a1.5 1.5 0 010-3h23a1.5 1.5 0 011.5 1.5z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgBank
